(function () {
  'use strict';

  function init(scope = document) {
    scope.querySelectorAll('[data-product-purchase-bar]').forEach((bar) => {
      if (bar.dataset.initialized) return;
      const root = document.getElementById(bar.dataset.purchaseId);
      const form = root?.querySelector('[data-bundle-form]');
      const submit = root?.querySelector('[data-bundle-submit]');
      if (!form || !submit) return;
      bar.dataset.initialized = 'true';
      const button = bar.querySelector('[data-product-bar-submit]');
      const options = bar.querySelector('[data-product-view-options]');
      const selection = bar.querySelector('[data-product-bar-selection]');
      const price = bar.querySelector('[data-product-bar-price]');
      const mobile = window.matchMedia('(max-width: 999px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const behavior = () => reducedMotion.matches ? 'instant' : 'smooth';
      let awaitingSummary = false;

      function sync() {
        const selected = root.querySelector('[data-bundle-set]:checked');
        const title = selected?.closest('label').querySelector('strong').textContent || '';
        const contents = root.querySelector('[data-bundle-total-context]').textContent;
        selection.textContent = title + ' · ' + contents;
        price.textContent = root.querySelector('[data-bundle-total]').textContent;
        button.textContent = submit.textContent;
        button.disabled = submit.disabled;
        const rect = submit.getBoundingClientRect();
        const primaryVisible = rect.top < window.innerHeight && rect.bottom > 0;
        const overlayOpen = document.querySelector('dialog[open], [data-cart-drawer].is-open') || document.body.style.overflow === 'hidden';
        bar.hidden = !mobile.matches || primaryVisible || Boolean(overlayOpen);
        document.body.classList.toggle('has-product-purchase-bar', !bar.hidden);
        const summary = root.querySelector('[data-bundle-summary]');
        if (awaitingSummary && !summary.hidden) {
          awaitingSummary = false;
          summary.scrollIntoView({ behavior: behavior(), block: 'center' });
        }
      }

      options.addEventListener('click', () => {
        root.querySelector('.bundle-purchase__sets').scrollIntoView({ behavior: behavior(), block: 'start' });
        root.querySelector('[data-bundle-set]:checked').focus({ preventScroll: true });
      });
      button.addEventListener('click', () => {
        if (submit.disabled) return;
        // Use the existing form handler for availability, cart errors and local previews.
        awaitingSummary = true;
        form.requestSubmit(submit);
        sync();
      });

      const intersection = new IntersectionObserver(sync);
      intersection.observe(submit);
      const purchaseObserver = new MutationObserver(sync);
      purchaseObserver.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'aria-busy'] });
      const overlayObserver = new MutationObserver(sync);
      document.querySelectorAll('dialog, [data-cart-drawer]').forEach((overlay) => overlayObserver.observe(overlay, { attributes: true, attributeFilter: ['open', 'class'] }));
      overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['style'] });
      mobile.addEventListener('change', sync);
      window.addEventListener('resize', sync);
      const cleanup = (event) => {
        if (!event.target.contains(bar)) return;
        intersection.disconnect();
        purchaseObserver.disconnect();
        overlayObserver.disconnect();
        mobile.removeEventListener('change', sync);
        window.removeEventListener('resize', sync);
        document.body.classList.remove('has-product-purchase-bar');
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
      sync();
    });
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
